import CustomDomainListCreateButton from "./CustomDomainListCreateButton";

export default CustomDomainListCreateButton;
